import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import { CreatePatientRecordContainer } from 'app/containers/DentalTreatmentManagement/CreatePatientRecord'

const CreatePatientRecordPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.add_patient_record)}</PageTitle>
      <CreatePatientRecordContainer />
    </>
  )
}
const CreatePatientRecordPage = memo(CreatePatientRecordPageCpn, isEqual)

export default CreatePatientRecordPage
